// @mui
import { alpha } from '@mui/material/styles';
//
import { createPalette } from './palette';

// ----------------------------------------------------------------------

export default function customShadows(mode = 'light') {
  const palette = createPalette(mode);
  const isLight = mode === 'light';
  
  const color = isLight ? palette.grey[500] : '#000';
  const shadowOpacity = isLight ? 0.16 : 0.4;
  
  const transparent = alpha(color, shadowOpacity);
  
  // Ensure palette colors exist before using them
  const primaryColor = palette?.primary?.main || '#569cd3';
  const secondaryColor = palette?.secondary?.main || '#3366FF';
  const infoColor = palette?.info?.main || '#1890FF';
  const successColor = palette?.success?.main || '#54D62C';
  const warningColor = palette?.warning?.main || '#FFC107';
  const errorColor = palette?.error?.main || '#FF4842';
  
  const colorShadowOpacity = isLight ? 0.24 : 0.32;
  
  return {
    z1: `0 1px 2px 0 ${transparent}`,
    z4: `0 4px 8px 0 ${transparent}`,
    z8: `0 8px 16px 0 ${transparent}`,
    z12: `0 12px 24px -4px ${transparent}`,
    z16: `0 16px 32px -4px ${transparent}`,
    z20: `0 20px 40px -4px ${transparent}`,
    z24: `0 24px 48px 0 ${transparent}`,
    //
    primary: `0 8px 16px 0 ${alpha(primaryColor, colorShadowOpacity)}`,
    info: `0 8px 16px 0 ${alpha(infoColor, colorShadowOpacity)}`,
    secondary: `0 8px 16px 0 ${alpha(secondaryColor, colorShadowOpacity)}`,
    success: `0 8px 16px 0 ${alpha(successColor, colorShadowOpacity)}`,
    warning: `0 8px 16px 0 ${alpha(warningColor, colorShadowOpacity)}`,
    error: `0 8px 16px 0 ${alpha(errorColor, colorShadowOpacity)}`,
    //
    card: `0 0 2px 0 ${alpha(color, 0.2)}, 0 12px 24px -4px ${alpha(color, 0.12)}`,
    dialog: `-40px 40px 80px -8px ${alpha(color, shadowOpacity * 1.5)}`,
    dropdown: `0 0 2px 0 ${alpha(color, shadowOpacity * 1.5)}, -20px 20px 40px -4px ${alpha(color, shadowOpacity * 1.5)}`,
    // Common shadow patterns used throughout the app
    elevated: `0px 0px 10px 4px ${alpha(color, shadowOpacity * 0.625)}`, // Common for cards and boxes
    soft: `0px 2px 6px 0px ${alpha(color, shadowOpacity * 0.5)}`, // Softer shadow for subtle elevation
    medium: `0px 4px 12px ${alpha(color, shadowOpacity * 0.625)}`, // Medium elevation
  };
}
